import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const GeneratorIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.5 12L19 8.5M22.5 12L19 15.5M22.5 12H16.75C16.0596 12 15.5 12.5596 15.5 13.25V13.5C15.5 14.0523 15.0523 14.5 14.5 14.5V14.5C13.9477 14.5 13.5 14.0523 13.5 13.5V8C13.5 7.44772 13.0523 7 12.5 7V7C11.9477 7 11.5 7.44771 11.5 8V17C11.5 17.5523 11.0523 18 10.5 18V18C9.94772 18 9.5 17.5523 9.5 17V6C9.5 5.44772 9.05228 5 8.5 5V5C7.94772 5 7.5 5.44772 7.5 6V14C7.5 14.5523 7.05228 15 6.5 15V15C5.94772 15 5.5 14.5523 5.5 14V9.5C5.5 8.94772 5.05228 8.5 4.5 8.5V8.5C3.94772 8.5 3.5 8.94772 3.5 9.5V10.5C3.5 11.3284 2.82843 12 2 12V12"
        stroke={fillColor || '#111112'}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { GeneratorIcon };
